function displayPrice(course) {
    if(course.left >= course.sessions) {
        return course.price;
    }

    if(!course.can_enroll_started) {
        return course.price;
    }

    if(course.left <= 0)
        return 0;

    return (course.price/course.sessions * course.left).toFixed(2);
}

function wechatPay(params) {
    if(typeof WeixinJSBridge == "undefined") {
        return Promise.reject("not in wechat");
    }

    return new Promise(function (resolve, reject) {
        WeixinJSBridge.invoke(
            'getBrandWCPayRequest', params,
            function(res){
                if(res.err_msg == "get_brand_wcpay_request:ok" ){
                    return resolve(res);
                } else {
                    return reject(res);
                }
            });
    });
}


function calcDistance(lat1, lon1, lat2, lon2)
{
    if(!lat1 || !lon1 || !lat2 || !lon2)
        return false;

    const R = 6371; // km
    const dLat = toRad(lat2-lat1);
    const dLon = toRad(lon2-lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    const d = R * c;
    return d.toFixed(1);
}

// Converts numeric degrees to radians
function toRad(Value)
{
    return Value * Math.PI / 180;
}

export default {displayPrice, wechatPay, calcDistance}